/*eslint-disable*/
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

// basics
import Util from "./Util";
import Template from "./Template";
import Api from "./Api";
import Views from "./Views";
import Helper from "./Helper";
import WindowEvent from "./WindowEvent";
import CartManager from "./CartManager";
import InnerCartManager from "./InnerCartManager";
import Tracker from "./Tracker";
import DebugConsole from "./debug/DebugConsole";
import SendLog from "./SendLog";
// navigation
import Navigation from "../ui/navigation/Navigation";
import Breadcrumb from "../ui/navigation/Breadcrumb";
import TabNavigation from "../ui/navigation/TabNavigation";
import FastScroll from "../ui/navigation/FastScroll";
// basicInfo
import BasicImage from "../ui/basicInfo/BasicImage";
import HotelBenefit from "../ui/basicInfo/HotelBenefit";
import RefundInfo from "../ui/basicInfo/RefundInfo";
import ReservationInfo from "../ui/basicInfo/ReservationInfo";
import TimeScheduleInfo from "../ui/basicInfo/TimeScheduleInfo";
import CustomerSatisfaction from "../ui/basicInfo/CustomerSatisfaction";
import PromotionBanner from "../ui/basicInfo/PromotionBanner";
import PromotionBannerPC from "../ui/basicInfo/PromotionBannerPC";
// 연관딜
import IntergratedDeals from "../ui/intergratedDeals/IntergratedDeals";
// description
import Notice from "../ui/description/Notice";
import Junsi from "../ui/description/Junsi";
import DealContents from "../ui/description/dealContent/DealContents";
import ContentsVideo from "../ui/description/dealContent/ContentsVideo";
import Sticky from "../ui/description/Sticky";
import WarningBanner from "../ui/description/WarningBanner";
// detailInfo
import DeliveryBanners from "../ui/detailInfo/DeliveryBanners";
import RefundBanners from "../ui/detailInfo/RefundBanners";
import RefundRule from "../ui/detailInfo/RefundRule";
import DealDescription from "../ui/detailInfo/DealDescription";
import PartnerInfoForDelivery from "../ui/detailInfo/PartnerInfoForDelivery";
import KCAuthInfo from "../ui/detailInfo/KCAuthInfo";
import ProductInfoNotes from "../ui/detailInfo/ProductInfoNotes";
import TradeInfo from "../ui/detailInfo/TradeInfo";
// PartnerInfo
import PartnerInfo from "../ui/partnerInfo/PartnerInfo";
import Map from "../ui/map/Map";
// feedback
import Review from "../ui/feedback/Review";
import Qna from "../ui/feedback/Qna";
// claim
import Claim from "../ui/claim/Claim";
// optionDetail
import OptionDetail from "../ui/optionDetail/OptionDetail";
// PartnerInfoDetail
import PartnerInfoDetail from "../ui/partnerInfoDetail/PartnerInfoDetail";
// purchase
import Purchase from "../ui/purchase/Purchase";
import PurchaseSelector from "../ui/purchase/PurchaseSelector";
import PurchaseInnerCart from "../ui/purchase/PurchaseInnerCart";
import PurchaseCalendar from "../ui/purchase/PurchaseCalendar";
// etc
import AdultCert from "../ui/adultCert/AdultCert";
import Error from "../ui/error/Error";
import Toast from "../ui/toast/Toast";
import CommonToast from "../ui/toast/CommonToast";
import ShareCapture from "../ui/toast/ShareCapture";
import FixedShare from "../ui/fixedShare/FixedShare";
import PlanningDeal from "../ui/basicInfo/PlanningDeal";
import ShareDealPopup from "../ui/shareDealPopup/ShareDealPopup";
// Store, React Component
import store from "../store";
import TopInfo from "../ui/topInfo/TopInfo";
import StoreReview from "../ui/topInfo/StoreReview/StoreReview";
import ErrorBoundary from "../ui/error/ErrorBoundary";
import { getContentViewParams, SINGULAR_CONFIG } from "../utils/singularUtils";
import Coupon from "../ui/d2c/Coupon";
import D2cInfo from "../ui/d2c/D2cInfo";
import DealReport from "../ui/description/DealReport";
import TmonPlayBanner from "../ui/tmonPlayBanner/TmonPlayBanner";
import AdviceNotice from "../ui/extra/AdviceNotice";

/**
 * @export
 * @class App
 * 페이지 전체를 관리하는 App
 */
class App {
  htStorage = {};

  /**
   * default view 에서 페이지가 onLoad 될 때 즉시 호출할 API 목록
   * 선언된 순서대로 호출하기 때문에 순서 관리가 필수적임
   */
  aInitDefaultApi = [
    // 탭 상단
    // 딜 기본 정보 관련 api
    "reviewType", // 별점, 구매후기 노출 여부
    // 구매혜택 관련 api
    "cardDiscount", // 카드 이벤트
    "cardMonthlyFree", // 무이자 할부
    // 대표리뷰 관련 api
    "representativeReview", // 대표리뷰
    // 판매자 품질 만족 지수 api
    "customerSatisfaction", // 판매자 품질 만족 지수
    // 쿠폰 요약 api
    "couponsSummary", // 신규회원, 쿠폰할인 영역
    // 탭 하단
    // 딜 기본 정보 관련 api
    "optionTree", // 옵션 정보
    // 상세정보 탭 관련 api
    "deliveryHolidayNotice", // 휴무배송일 정보
    // 구매하기 관련 api
    "payCustomDeals", // 결제수단
    "orderCount", // 사용자의 카트, 구매 횟수
    "d2cInfo", // 딜상세 통합채널 정보
    "viewAreaGetByDealNo" // 전시 데이터(딜번호로 조회)
  ];

  /**
   * storage의 값이 변경되었을 때 할 동작을 지정한 유사 Promise 객체
   * 이 객체는 map의 형태를 지니며, 각각의 항목 객체의 형태는 다음과 같음
   *  {{
   *      aInitRequireKey 객체를 초기화하는 데 필요한 storage의 목록
   *      bResolved 객체가 초기화되었는지 여부를 저장하는 값
   *      fnInit aInitRequireKey가 모두 있을 때 실행할 함수
   *      aUpdateRequireKey 객체를 변경하는 데 필요한 storage의 목록
   *      fnUpdate aUpdateRequireKey 중 하나가 변경되었을 때 실행할 함수
   *      fnUnload 페이지의 unload가 발생할 때 실행할 함수
   *  }}
   */
  htPromise = {
    static: {
      aInitRequireKey: ["htStaticData"],
      bResolved: false,
      fnInit: () => {
        try {
          this.oWindowEvent = new WindowEvent();
          this.oNavigation = new Navigation();
          this.oBreadcrumb = new Breadcrumb();
          this.oBasicImage = new BasicImage();
          this.isLoadedYoutubePlayer = false;
          this.oRefundInfo = new RefundInfo();
          this.oReservationInfo = new ReservationInfo();
          this.oTimeShceduleInfo = new TimeScheduleInfo();
          this.oHotelBenefit = new HotelBenefit();
          if (TMON.sDevice !== "PW") {
            this.oPromotionBanner = new PromotionBanner();
            this.oFixedShare = new FixedShare();
            new DealReport();
          } else {
            new PromotionBannerPC();
            // 딜상세 티몬플레이 플로팅 banner
            new TmonPlayBanner();
          }
          if (TMON.htStaticData.isShareDeal) {
            this.oShareDealPopup = new ShareDealPopup();
            this.oFixedShare = new FixedShare();
          }
          if (TMON.view_mode === "app") {
            this.oShareCapture = new ShareCapture();
          }
          this.oDeliveryBanners = new DeliveryBanners();
          new RefundBanners();
          this.oRefundRule = new RefundRule();
          this.oDealDescription = new DealDescription();
          this.oKCAuthInfo = new KCAuthInfo();
          this.oProductInfoNotes = new ProductInfoNotes();
          this.oTradeInfo = new TradeInfo();
          new Claim();
          new PlanningDeal();
          this.oCommonToast = new CommonToast();
        } catch (e) {
          this.errorHandler({ error: e });
        }
      },
      fnUnload: () => {
        this.clearEvent();
        if (this.oWindowEvent) {
          this.oWindowEvent.clearEvent();
        }
        if (this.oBreadcrumb) {
          this.oBreadcrumb.clearEvent();
        }
        if (this.oBasicImage) {
          this.oBasicImage.clearEvent();
        }
        if (this.oRefundInfo) {
          this.oRefundInfo.clearEvent();
        }
        if (this.oReservationInfo) {
          this.oReservationInfo.clearEvent();
        }
        if (this.oHotelBenefit) {
          this.oHotelBenefit.clearEvent();
        }
        if (this.oPromotionBanner) {
          this.oPromotionBanner.clearEvent();
        }
        if (this.oDeliveryBanners) {
          this.oDeliveryBanners.clearEvent();
        }
        if (this.oRefundRule) {
          this.oRefundRule.clearEvent();
        }
        if (this.oDealDescription) {
          this.oDealDescription.clearEvent();
        }
        if (this.oKCAuthInfo) {
          this.oKCAuthInfo.clearEvent();
        }
        if (this.oProductInfoNotes) {
          this.oProductInfoNotes.clearEvent();
        }
        if (this.oTradeInfo) {
          this.oTradeInfo.clearEvent();
        }
        if (this.oPurchasePoint) {
          this.oPurchasePoint.clearEvent();
        }
        if (this.oShareCapture) {
          this.oShareCapture.clearEvent();
        }
      },
    },
    tracker: {
      aInitRequireKey: ["htStaticData"],
      aUpdateRequireKey: ["sendTracker"],
      bResolved: false,
      fnInit: () => {
        this.oTracker = new Tracker();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oTracker) {
          this.oTracker.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oTracker) {
          this.oTracker.clearEvent();
        }
      },
    },
    adultCert: {
      aInitRequireKey: ["htStaticData"],
      aUpdateRequireKey: ["openAdultCert"],
      bResolved: false,
      fnInit: () => {
        this.oAdultCert = new AdultCert();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oAdultCert) {
          this.oAdultCert.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oAdultCert) {
          this.oAdultCert.clearEvent();
        }
      },
    },
    customerSatisfaction: {
      aInitRequireKey: ["customerSatisfaction"],
      bResolved: false,
      fnInit: () => {
        new CustomerSatisfaction();
      },
    },
    qna: {
      aInitRequireKey: ["reviewType"],
      aUpdateRequireKey: [
        "qnaList",
        "qnaAdd",
        "qnaModify",
        "qnaAddReply",
        "qnaDelete",
        "qnaDeleteReply",
        "qnaReport",
      ],
      bResolved: false,
      fnInit: () => {
        this.oQna = new Qna();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oQna) {
          this.oQna.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oQna) {
          this.oQna.clearEvent();
        }
      },
    },
    tabNavigation: {
      aInitRequireKey: ["reviewType"],
      aUpdateRequireKey: ["defaultFinally", "qnaList", "representativeReview"],
      bResolved: false,
      fnInit: () => {
        this.oTabNavigation = new TabNavigation();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oTabNavigation) {
          this.oTabNavigation.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oTabNavigation) {
          this.oTabNavigation.clearEvent();
        }
      },
    },
    tabAndSticky: {
      aInitRequireKey: ["tab", "sticky"],
      aUpdateRequireKey: ["tab", "sticky"],
      bResolved: false,
      fnInit: () => {
        if (this.sPlatform !== "PW") {
          this.oFastScroll = new FastScroll();
        }
        this.oSticky = new Sticky();
      },
      fnUpdate: () => {
        if (this.oFastScroll) {
          this.oFastScroll.update();
        }
        if (this.oSticky) {
          this.oSticky.update();
        }
      },
      fnUnload: () => {
        if (this.oFastScroll) {
          this.oFastScroll.clearEvent();
        }
        if (this.oSticky) {
          this.oSticky.clearEvent();
        }
      },
    },
    notice: {
      aInitRequireKey: ["htStaticData", "deliveryHolidayNotice"],
      bResolved: false,
      fnInit: () => {
        this.oNotice = new Notice();
      },
      fnUnload: () => {
        if (this.oNotice) {
          this.oNotice.clearEvent();
        }
      },
    },
    warningBanner: {
      aInitRequireKey: ["htStaticData"],
      bResolved: false,
      fnInit: () => {
        new WarningBanner([
          [["52130000"], [TMON.htStaticData.htCategoryInfo.sDepth2No || ""]],
        ]);
      },
      fnUnload: () => {},
    },
    dealContents: {
      aInitRequireKey: ["htStaticData", "optionTree"],
      aUpdateRequireKey: [
        "selectedActionIndex",
        "setSummaryOptionHeight",
        "splitContent",
        "scene",
      ],
      bResolved: false,
      fnInit: () => {
        this.oDealContents = new DealContents();
        try {
          this.oContentsVideo = new ContentsVideo();
        } catch (e) {
          this.errorHandler({ error: e });
        }
      },
      fnUpdate: (sStorageKey) => {
        if (this.oDealContents) {
          this.oDealContents.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oDealContents) {
          this.oDealContents.clearEvent();
        }
        if (this.oContentsVideo) {
          this.oContentsVideo.clearEvent();
        }
      },
    },
    intergratedDeals: {
      aInitRequireKey: ["htStaticData"],
      bResolved: false,
      fnInit: () => {
        new IntergratedDeals();
      },
      fnUnload: () => {
        if (this.oIntergratedPaginate) {
          this.oIntergratedPaginate.clearEvent();
        }
      },
    },
    d2cInfo: {
      aInitRequireKey: ["d2cInfo"],
      fnInit: () => {
        if (TMON.htStaticData.htDealInfo.isChnlDeal && TMON.sDevice !== "PW") {
          Coupon.init();
          D2cInfo.init();
          document.querySelector("body").classList.add("d2c");
        }
      },
    },
    partnerInfoForDelivery: {
      aInitRequireKey: ["htStaticData"],
      aUpdateRequireKey: ["partnerInfo"],
      bResolved: false,
      fnInit: () => {
        this.oPartnerInfoForDelivery = new PartnerInfoForDelivery();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oPartnerInfoForDelivery) {
          this.oPartnerInfoForDelivery.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oPartnerInfoForDelivery) {
          this.oPartnerInfoForDelivery.clearEvent();
        }
      },
    },
    review: {
      aInitRequireKey: [
        "tab",
        "reviewType",
        "reviewSurveyStatistics",
        "photoReviewList",
        "photoReviewImageCount",
        "reviewOptionTree",
      ],
      aUpdateRequireKey: [
        "photoReviewList",
        "reviewList",
        "login",
        "reportReview",
        "recommendReview",
        "recommendationReview",
        "cancelRecommendationReview",
        "deleteReview",
      ],
      bResolved: false,
      fnInit: () => {
        this.oReview = new Review();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oReview) {
          this.oReview.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oReview) {
          this.oReview.clearEvent();
        }
      },
    },
    sendLog: {
      aInitRequireKey: ["htStaticData"],
      aUpdateRequireKey: ["sendGAByParam"],
      bResolved: false,
      fnInit: () => {
        this.oSendLog = new SendLog();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oSendLog) {
          this.oSendLog.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oSendLog) {
          this.oSendLog.clearEvent();
        }
      },
    },
    purchase: {
      aInitRequireKey: ["htStaticData"],
      aUpdateRequireKey: [
        "scene",
        "innerCartItems",
        "payCustomDeal",
        "purchaseDrawer",
        "resizeFloatingInnerCart",
        "closeLayer",
        "subscriptionConfirm",
      ],
      bResolved: false,
      fnInit: () => {
        this.oPurchase = new Purchase();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oPurchase) {
          this.oPurchase.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oPurchase) {
          this.oPurchase.clearEvent();
        }
      },
    },
    purchaseSelector: {
      aInitRequireKey: ["optionTree"],
      aUpdateRequireKey: [
        "scene",
        "purchaseOption",
        "checkOut",
        "pickDate",
        "drawCalenderFinish",
        "optionTree",
      ],
      bResolved: false,
      fnInit: () => {
        this.oPurchaseSelector = new PurchaseSelector();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oPurchaseSelector) {
          this.oPurchaseSelector.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oPurchaseSelector) {
          this.oPurchaseSelector.clearEvent();
        }
      },
    },
    purchaseInnerCart: {
      aInitRequireKey: ["htStaticData"],
      aUpdateRequireKey: ["initInnerCart", "innerCartItems"],
      bResolved: false,
      fnInit: () => {
        this.oPurchaseInnerCart = new PurchaseInnerCart();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oPurchaseInnerCart) {
          this.oPurchaseInnerCart.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oPurchaseInnerCart) {
          this.oPurchaseInnerCart.clearEvent();
        }
      },
    },
    purchaseCalendar: {
      aInitRequireKey: ["optionTree"],
      aUpdateRequireKey: [
        "checkIn",
        "checkOut",
        "pickDate",
        "optionTree",
        "optionList",
        "purchaseOption",
      ],
      bResolved: false,
      fnInit: () => {
        this.oPurchaseCalendar = new PurchaseCalendar();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oPurchaseCalendar) {
          this.oPurchaseCalendar.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oPurchaseCalendar) {
          this.oPurchaseCalendar.clearEvent();
        }
      },
    },
    optionDetail: {
      aInitRequireKey: ["htStaticData", "renderDetailViewAvailable"],
      aUpdateRequireKey: ["scene", "optionTree", "splitContent", "optionList"],
      bResolved: false,
      fnInit: () => {
        this.oOptionDetail = new OptionDetail();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oOptionDetail) {
          this.oOptionDetail.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oOptionDetail) {
          this.oOptionDetail.clearEvent();
        }
      },
    },
    partnerInfoDetail: {
      aInitRequireKey: ["htStaticData"],
      aUpdateRequireKey: ["partnerInfoDetail"],
      bResolved: false,
      fnInit: () => {
        this.oPartnerInfoDetail = new PartnerInfoDetail();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oPartnerInfoDetail) {
          this.oPartnerInfoDetail.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oPartnerInfoDetail) {
          this.oPartnerInfoDetail.clearEvent();
        }
      },
    },
    error: {
      aInitRequireKey: ["errorScene"],
      aUpdateRequireKey: ["errorScene"],
      bResolved: false,
      fnInit: () => {
        this.oError = new Error();
      },
      fnUpdate: () => {
        if (this.oError) {
          this.oError.update();
        }
      },
    },
    toast: {
      aInitRequireKey: ["htStaticData"],
      aUpdateRequireKey: ["toast"],
      bResolved: false,
      fnInit: () => {
        this.oToast = new Toast();
      },
      // 사용 예시 : TMON.oApp.setStorage('toast', '담겼습니다');
      fnUpdate: (sStorageKey) => {
        if (this.oToast) {
          this.oToast.update(sStorageKey);
        }
      },
    },
    map: {
      aInitRequireKey: ["htStaticData"],
      aUpdateRequireKey: ["tab", "scene", "setCurrentLocation", "renderMap"],
      bResolved: false,
      fnInit: () => {
        this.oMap = new Map();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oMap) {
          this.oMap.update(sStorageKey);
        }
      },
    },
    partnerInfo: {
      aInitRequireKey: ["htStaticData"],
      bResolved: false,
      fnInit: () => {
        this.oPartnerInfo = new PartnerInfo();
      },
      fnUnload: () => {
        if (this.oPartnerInfo) {
          this.oPartnerInfo.clearEvent();
        }
      },
    },
    cart: {
      aInitRequireKey: ["htStaticData"],
      aUpdateRequireKey: ["willAddToCart", "addCartItems"],
      bResolved: false,
      fnInit: () => {
        this.oCartManager = new CartManager();
      },
      // 사용 예시 : TMON.oApp.setStorage('willAddToCart', {sMainDealSrlForCart: '', aOptionNoForCart: [],aCountForCart: [],nTotalValue: ''});
      fnUpdate: (sStorageKey) => {
        if (this.oCartManager) {
          this.oCartManager.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oCartManager) {
          this.oCartManager.clearEvent();
        }
      },
    },
    innerCart: {
      aInitRequireKey: ["htStaticData", "optionTree", "orderCount"],
      aUpdateRequireKey: [
        "purchaseOption",
        "validateBuyNow",
        "validateAddToInnerCart",
        "validateAddToCart",
        "validateBuyGift",
        "optionList",
        "delInnerCartItem",
        "adjInnerCartItemCount",
        "buyNow",
        "addCartItems",
        "buyGift",
        "getEmailOptIn",
        "putEmailOptIn",
      ],
      bResolved: false,
      fnInit: () => {
        this.oInnerCartManager = new InnerCartManager();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oInnerCartManager) {
          this.oInnerCartManager.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oInnerCartManager) {
          this.oInnerCartManager.clearEvent();
        }
      },
    },
    adviceNotice: {
      aInitRequireKey: ["htStaticData", "representativeReview"],
      aUpdateRequireKey: ["purchaseDrawer"],
      bResolved: false,
      fnInit: () => {
        this.oAdviceNotice = new AdviceNotice();
      },
      fnUpdate: (sStorageKey) => {
        if (this.oAdviceNotice) {
          this.oAdviceNotice.update(sStorageKey);
        }
      },
      fnUnload: () => {
        if (this.oAdviceNotice) {
          this.oAdviceNotice.clearEvent();
        }
      },
    },
    junsi: {
      aInitRequireKey: ["viewAreaGetByDealNo"],
      bResolved: false,
      fnInit: () => {
        this.oJunsi = new Junsi();
      },
      fnUnload: () => {
        if (this.oJunsi) {
          this.oJunsi.clearEvent();
        }
      },
    },
    defaultFinally: {
      aInitRequireKey: this.aInitDefaultApi,
      bResolved: false,
      fnInit: () => {
        window.oDebugMode.log("app.js > defaultFinally", true);
        TMON.oApp.setStorage("defaultFinally", true);
      },
    },
  };

  /**
   * 서버에서 모델로 내려온 ABTest String 을 JSON 형태로 변환한다. ABTest 코드가 있어야만 동작하는 코드블럭이 많으므로 가능한 빨리 이 함수를 호출해야 한다.
   */
  parseABTestJSON() {
    try {
      this.htABTest = JSON.parse(TMON.htStaticData.sABTestJSON);
    } catch (e) {
      console.error(e);
      this.htABTest = {};
    }
  }

  /**
   * App 초기화
   */
  init() {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    this.parseABTestJSON();
    window.oDebugMode.log("app.js > constructor", false);
    if (TMON.sDevice !== "PW" && !TMON.htStaticData.htDealInfo.isChnlDeal) {
      document.querySelector(".d2c_coupon").remove();
      document.querySelector(".d2c_home").remove();
    }
    this.cloneHeader();

    // set instances
    this.oTemplate = new Template();
    this.oHelper = new Helper();
    this.oUtil = new Util();
    this.oApi = new Api();
    this.oViews = new Views();

    // set sPlatform (one of PW, MW, MA)
    this.sPlatform = this.oUtil.getPlatform();

    // set isTouchDevice
    this.isTouchDevice = this.oUtil.isTouchDevice();

    this.initViews();
    this.setEvent();
    this.initReactComponent();

    if ($("#debugMode").length) {
      this.oDebugConsole = new DebugConsole();
    }
  }

  /**
   * 페이지 진입 시 scene 해시에 의해 View를 초기화
   */
  initViews() {
    let sSceneType = TMON.htStaticData.sDefaultScene;
    if (TMON.util.getHashJSON().scene) {
      sSceneType = TMON.util.getHashJSON().scene;

      // 옵션 자세히 보기 레이어 띄워진 경우 새로고침시 splitContent data가 필요하여 default API에 포함
      if (TMON.util.getHashJSON().scene === "scene-optiondetail") {
        this.aInitDefaultApi.push("splitContent");
        this.htPromise.dealContents.aInitRequireKey.push("splitContent");
        this.htPromise.optionDetail.aInitRequireKey.push("splitContent");
      }
    }
    this.setViews(TMON.htStaticData.sDefaultView, sSceneType);
  }

  /**
   * 현재 view, scene 를 변경한다
   * @param sViewType 바꿀 페이지의 ViewType
   * @param sSceneType 바꿀 페이지의 SceneType
   */
  setViews(sViewType, sSceneType = null) {
    this.oViews.setViews(sViewType, sSceneType);
  }

  setEvent() {
    // footer내의 링크에서 브라우저 앱 이탈(unload가 발생한 뒤에 다시 상세 페이지로 돌아오게 될 경우)로 인해 beforeunload event를 발생시키는 것을 방지
    $("footer").on("click", "a", () => {
      TMON.oApp.setStorage("bBlockWindowUnloadEvent", true);
    });

    // 페이지 이탈 시 eventListener 등록
    $(window).on("beforeunload", () => {
      // 앱 이탈(unload가 발생한 뒤에 다시 상세 페이지로 돌아오게 될 경우)에는 unloadEvent 발생시키지 않음(ex. 전화 걸기)
      if (TMON.oApp.getStorage("bBlockWindowUnloadEvent") === true) {
        TMON.oApp.setStorage("bBlockWindowUnloadEvent", false);
      } else {
        this.onWindowUnload();
      }
    });

    /* 레이어 닫기 eventListener 등록 */
    $("#view-default-scene-optiondetail").on(
      "click",
      "[data-role=close]",
      this.closeLayerAction
    );
    $("#view-default-scene-review").on(
      "click",
      "[data-role=close]",
      this.closeLayerAction
    );
    $(".scene_dimmed_bg").on("click", this.closeLayerAction);
    $("#_layerContainer").on(
      "click",
      "[data-role=close]",
      this.closeLayerAction
    );
    $("#_dimmedOnPc").on("click", this.closeLastOpenLayer);
    $(window).on("keydown", (e) => {
      if (e.keyCode === 27 && TMON.util.getHashJSON().scene) {
        this.closeLayerAction(e);
      }
    });
    /* \\ 레이어 닫기 eventListener 등록 */
  }

  /**
   * errorScene 여부에 따라 React Component 랜더링
   */
  initReactComponent() {
    const preventInit = () => {
      const isErrorScene = this.htStorage.errorScene;
      const isAdultAndNotCert =
        this.htViews.view === "view-adultcert" &&
        !TMON.htStaticData.isAdultCert;

      return Boolean(isErrorScene || isAdultAndNotCert);
    };

    if (preventInit()) return;

    ReactDOM.render(
      <ErrorBoundary>
        <Provider store={store}>
          <TopInfo />
        </Provider>
      </ErrorBoundary>,
      document.getElementById("_dealInfoWrap")
    );

    ReactDOM.render(
      <ErrorBoundary>
        <Provider store={store}>
          <StoreReview />
        </Provider>
      </ErrorBoundary>,
      document.getElementById("_dealReviewWrap")
    );
  }

  clearEvent() {
    $("footer").off("click", "a");
    $(window).off("beforeunload");
    $("#view-default-scene-optiondetail").off("click", "[data-role=close]");
    $("#view-default-scene-review").off("click", "[data-role=close]");
    $(".scene_dimmed_bg").off("click");
    $("#_layerContainer").off("click", "[data-role=close]");
    $("#_dimmedOnPc").off("click");
    $(window).off("keydown");
  }

  /**
   * 함수 호출시점의 최신 storage 반환
   * @param sStorageKey
   * @returns {*}
   */
  getStorage(sStorageKey = null) {
    if (sStorageKey) {
      return this.htStorage[sStorageKey];
    }

    return this.htStorage;
  }

  /**
   * TMON.htStaticData.bUseErrorHandler 에 의해 errorHandler 사용 여부를 체크하고, storage 값을 업데이트
   * @param sStorageKey 업데이트 할 storage의 키 값
   * @param oValue 업데이트할 값
   */
  setStorage(sStorageKey, oValue) {
    if (window.bLoadingNow) {
      window.bLoadingNow = false;
    }
    window.oDebugMode.storage(sStorageKey, oValue);

    if (TMON.htStaticData.bUseErrorHandler) {
      try {
        this.setStorageAction(sStorageKey, oValue);
      } catch (e) {
        this.errorHandler({
          from: "setStorage",
          error: e,
          storageKey: sStorageKey,
          value: oValue,
        });
      }
    } else {
      this.setStorageAction(sStorageKey, oValue);
    }
  }

  /**
   * storage 값을 업데이트
   * @param sStorageKey 업데이트 할 storage의 키 값
   * @param oValue 업데이트할 값
   */
  setStorageAction(sStorageKey, oValue) {
    this.htStorage[sStorageKey] = oValue;
    const aRefinedStorageKey = this.oHelper.getRefineData(sStorageKey, oValue);
    $.each(
      aRefinedStorageKey,
      $.proxy((index) => {
        this.onChangeStorage(aRefinedStorageKey[index]);
      })
    );
  }

  /**
   * storage 값이 업데이트되었을 때 호출되는 함수
   * @param sStorageKey 업데이트 된 storage의 키 값
   */
  onChangeStorage(sStorageKey) {
    $.each(
      this.htPromise,
      $.proxy((key) => {
        // update 조건 검사
        if (this.htPromise[key].aUpdateRequireKey) {
          $.each(
            this.htPromise[key].aUpdateRequireKey,
            $.proxy((index) => {
              if (
                this.htPromise[key].aUpdateRequireKey[index] === sStorageKey
              ) {
                this.updateComponent(key, sStorageKey);
              }
            }, this)
          );
        }
        // init 조건 검사
        if (!this.htPromise[key].bResolved) {
          // 아직 한번도 init 되지 않은 UI(bResolved 가 false 인 UI)만 검사
          this.htPromise[key].aInitRequireKey = $.grep(
            this.htPromise[key].aInitRequireKey,
            (value) => value !== sStorageKey
          );
          if (this.htPromise[key].aInitRequireKey.length < 1) {
            this.htPromise[key].bResolved = true;
            this.initComponent(key);
          }
        }
      }, this)
    );
  }

  /**
   * htPromise 객체 각 항목의 fnInit을 실행
   * @param sItemName fnInit을 실행할 htPromise 객체의 항목
   */
  initComponent(sItemName) {
    if (TMON.htStaticData.bUseErrorHandler) {
      try {
        this.htPromise[sItemName].fnInit();
      } catch (e) {
        // UI Component 를 init 하는 과정에서 내부 오류가 발생하면 여기서 catch 됨
        this.errorHandler({
          error: e,
          componentName: sItemName,
        });
      }
    } else {
      this.htPromise[sItemName].fnInit();
    }
  }

  /**
   * htPromise 객체 각 항목의 fnUpdate를 실행
   * @param sItemName fnUpdate을 실행할 htPromise 객체의 항목
   * @param sStorageKey 변경된 storage의 이름
   */
  updateComponent(sItemName, sStorageKey) {
    if (TMON.htStaticData.bUseErrorHandler) {
      try {
        this.htPromise[sItemName].fnUpdate(sStorageKey);
      } catch (e) {
        // UI Component 를 init 하는 과정에서 내부오류가 발생하면 여기서 catch 됩니다.
        this.errorHandler({
          error: e,
          componentName: sItemName,
          storageKey: sStorageKey,
        });
      }
    } else {
      this.htPromise[sItemName].fnUpdate(sStorageKey);
    }
  }

  /**
   * error 발생 시 처리
   * @param htErrorInfo 에러에 대한 정보를 담은 객체
   *  {{
   *      {object} error 에러 이벤트 자체
   *      {string} componentName init/update 시 오류 발생한 컴포넌트명
   *      {string} storageKey 오류가 발생한 storageKey
   *      {object} value 오류가 발생한 시점의 storageKey 내용
   *      {string} from 오류가 발생한 위치(호출 객체)
   *      {number} actionType alert / gotoError
   *      {number} actionValue
   *      {booolean} bLoggingEslog 이슬로그 전송여부 (기본값: false)
   *  }}
   */
  errorHandler(htErrorInfo) {
    if (htErrorInfo.bLoggingEslog && TMON.htStaticData.bUseEslogOnError) {
      TMON.oApp.oApi.fetchApi("sendError", {
        htErrorInfo: JSON.stringify(htErrorInfo),
      });
    }

    switch (htErrorInfo.actionType) {
      case "alert":
        alert("htErrorInfo.actionValue");
        break;
      case "gotoError":
        TMON.oApp.setViews(
          "view-error",
          htErrorInfo.actionValue ? htErrorInfo.actionValue : "scene-default"
        );
        break;
      default:
        break;
    }

    this.setStorage("debug", htErrorInfo);
    console.warn(htErrorInfo);
    console.error("ERROR LOG", htErrorInfo.error);
  }

  /**
   * 페이지 이탈 시 eventListener
   * beforeunload 이벤트 발생 시 실행
   */
  onWindowUnload() {
    // 딜상세 이탈시 대기페이지 토큰 만료 API 호출
    navigator.sendBeacon("/api/deals/qtms/expire");

    if (
      TMON.oApp.sPlatform !== "MA" &&
      TMON.htStaticData.sDeployPhase !== "LOCAL"
    ) {
      return; // 앱에서만 동작해야 하기 때문에, 모바일웹과 PC웹에서는 리턴한다. 단, 원활한 개발을 위해 로컬 개발환경에서는 노출한다.
    }
    $.each(
      this.htPromise,
      $.proxy((key) => {
        if (this.htPromise[key].fnUnload) {
          this.unloadComponent(key);
        }
      }, this)
    );
  }

  /**
   * 페이지의 unload가 발생할 때 htPromise 객체 각 항목의 fnUnload를 실행
   * @param sItemName fnUnload를 실행할 htPromise 객체의 항목
   */
  unloadComponent(sItemName) {
    if (TMON.htStaticData.bUseErrorHandler) {
      try {
        this.htPromise[sItemName].fnUnload();
      } catch (e) {
        // UI Component 를 unload 하는 과정에서 내부오류가 발생하면 여기서 catch 됩니다.
        this.errorHandler({
          error: e,
          componentName: sItemName,
        });
      }
    } else {
      this.htPromise[sItemName].fnUnload();
    }
  }

  /**
   * 레이어 닫기 eventListener
   */
  closeLayerAction = (e) => {
    if (
      $(e.currentTarget)
        .closest(".pop, .popup")
        .attr("data-pullToRefresh") === "false" &&
      TMON.oApp.sPlatform === "MA"
    ) {
      TMON.app.callApp(
        "webview",
        "setWebProperties",
        '{"nestedScrollEnable": true}'
      );
    }

    let bWillHistoryBack = false; // window.history.back 을 할지 여부
    if (!e && this.getStorage("hasHashChanged")) {
      bWillHistoryBack = true;
    } else if (!e && !this.getStorage("hasHashChanged")) {
      TMON.oApp.setStorage("openLayerInApplication", false);
      window.location.hash = "";
    } else if (
      $(e.currentTarget)
        .closest(".pop, .popup")
        .attr("data-closeType") === "remove"
    ) {
      $(e.currentTarget)
        .closest(".pop, .popup")
        .hide();
    } else if (
      TMON.oApp.getStorage("openLayerInApplication") ||
      TMON.oApp.sPlatform !== "PW"
    ) {
      bWillHistoryBack = true;
    } else {
      TMON.oApp.setStorage("openLayerInApplication", false);
      if (window.location.hash.length !== 0) window.location.hash = "";
    }

    if (bWillHistoryBack) {
      const sCurrentLocationHref = window.location.href; // 현재 페이지를 기록해놓고
      window.history.back(); // 이전 페이지가 있다면 window.history.back 을 해본다.
      if (
        sCurrentLocationHref === window.location.href ||
        window.history.referrer < 2
      ) {
        // 혹시 이전 페이지로 돌아가지 못했다면 (SDLUI-265)
        TMON.oApp.oViews.closeLayer();
      }
    }
    this.closeDimmedOnPc();
  };

  closeDimmedOnPc() {
    if (TMON.oApp.sPlatform === "PW") {
      $("#_dimmedOnPc").hide();
    }
    $("#_layerContainer").hide();
  }

  /**
   * 레이어 닫기 eventListener
   */
  closeLastOpenLayer = () => {
    const htLastOpenLayer = this.getStorage("htLastOpenLayer");
    htLastOpenLayer.welLastOpenLayer.hide();

    // close Dimmed On Pc
    if (TMON.oApp.sPlatform === "PW") {
      $("#_dimmedOnPc").hide();
    }
    $("#_layerContainer").hide();
  };

  /**
   * view 혹은 scene 이 변경되었을 때 호출되는 함수
   * @param sViewType 변경된 페이지의 ViewType
   * @param sSceneType 변경된 페이지의 SceneType
   * @param bChangedView view가 바뀌었는지 판별한 값
   * @param bChangedScene scene이 바뀌었는지 판별한 값
   */
  onChangeViews(
    sViewType,
    sSceneType,
    sPrevViewType,
    sPrevSceneType,
    bChangedView = false,
    bChangedScene = false
  ) {
    this.htViews = {
      view: sViewType,
      scene: sSceneType,
      prevView: sPrevViewType,
      prevScene: sPrevSceneType,
    };

    $("body").removeClass("view-error view-adultcert view-default");
    $("body").addClass(sViewType);
    $("[data-role=view]").hide();
    $(`[data-role=view]#${sViewType}`).show();

    if (bChangedView) {
      switch (sViewType) {
        case "view-default":
          this.setDefaultStorage();
          this.callDefaultApi();
          break;
        case "view-adultcert":
          if (!this.oAdultCert) {
            this.oAdultCert = new AdultCert();
          }
          break;
        case "view-error":
          this.setStorage("errorScene", sSceneType);
          if (!this.oError) {
            this.oError = new Error();
          }
          break;
        default:
          break;
      }
    }

    if (bChangedScene) {
      switch (sViewType) {
        case "view-default":
          this.setViewDefaultScene();
          break;
        default:
          break;
      }
    }
  }

  /**
   * API 호출을 하지 않고 준비할 수 있는 기본 Storage(htStaticData) 를 설정
   */
  setDefaultStorage() {
    this.htStorage = {};
    this.setStorage("htStaticData", TMON.htStaticData);

    // 딜상세 진입시 컨텐츠 확인 트래킹을 위한 콜앱 호출(SDLUI-1218)
    const trackingParams = getContentViewParams();

    this.oTracker.dealTracking(
      trackingParams,
      SINGULAR_CONFIG.eventName.contentView
    );
  }

  /**
   * default view 에서 페이지 onload 시 즉시 호출해도 되는 api들을 순차적으로 호출
   */
  async callDefaultApi() {
    let bFetch = true; // API 호출할지 말지 여부

    // reviewType 처리 된후 'defaultFinally', 'qnaList', 'representativeReview' 가 호출되어야함.
    await this.oApi.fetchApi("reviewType", null, "default");

    $.each(
      this.aInitDefaultApi,
      $.proxy((index) => {
        switch (this.aInitDefaultApi[index]) {
          case "optionTree":
            // 옵션 전체 목록 > 판매 중이 아닌 딜은 optionTree를 요청하지 않는다(단 판매 대기인 상품은 예외)
            if (!TMON.htStaticData.isSale && !TMON.htStaticData.isBeforeOpen) {
              bFetch = false;
              this.setStorage("optionTree", { data: null });
            }
            break;
          case "deliveryHolidayNotice":
            if (!TMON.oApp.htStorage.htStaticData.htDealInfo.partnerNo) {
              // 배송휴무일 정보는 파트너번호가 필수이므로 없으면 호출하지 않는다.
              bFetch = false;
              this.setStorage("deliveryHolidayNotice", {
                data: null,
              });
            }
            break;
          case "reviewType":
            return;
          default:
            break;
        }

        if (bFetch === true) {
          this.oApi.fetchApi(this.aInitDefaultApi[index], null, "default");
        }

        bFetch = true;
      }, this)
    );
  }

  /**
   * view 가 view-default 일 때, 각 scene 에 따른 화면의 상태를 관리
   */
  setViewDefaultScene() {
    if (this.htViews.scene !== "scene-default") {
      this.setScrollToStorage();
    }

    // 상세 팝업 띄울 때 상품 상세보기 이미지가 한꺼번에 불러와지는 이슈 해결
    if (this.htViews.scene === "scene-optiondetail") {
      if (TMON.sDevice !== "PW") $("#_wrapDealContents").css("display", "none");
    }

    $("body").removeClass(
      "scene-default scene-optiondetail scene-partnerinfo scene-review"
    );
    $("body").addClass(this.htViews.scene);
    switch (this.htViews.scene) {
      // 기본 화면
      case "scene-default":
        this.setStorage("scene", "default");
        if (TMON.sDevice !== "PW") {
          this.setScrollToWindow();
          /**
           * @description
           * [SDLUI-886] 과제에 따라 주석 처리
           */
          // $('meta[name=viewport]').attr('content', 'initial-scale=1, width=device-width, height=device-height, minimal-ui');
        } else {
          TMON.util.unfixBodyForLayer();
        }
        break;
      // 옵션별 자세히보기
      case "scene-optiondetail":
        this.setStorage("scene", "optionDetail");
        if (TMON.sDevice !== "PW") {
          $("meta[name=viewport]").attr(
            "content",
            "initial-scale=1, minimum-scale=1, maximum-scale=2, width=device-width, height=device-height, minimal-ui"
          );
        } else {
          TMON.util.fixBodyForLayer(true);
        }
        break;
      // 업체정보 > 지도 보기
      case "scene-partnerinfo":
        $("body").addClass("scene-partnerinfo");
        this.setStorage("scene", "partnerInfo");
        break;
      case "scene-review":
        TMON.oApp.enableTab({ sTabId: "review", bScrollToTab: true });
        if (TMON.sDevice === "PW") {
          TMON.util.fixBodyForLayer(true);
        }
        $("body").addClass("scene-review");
        this.setStorage("scene", "review");
        break;
      default:
        break;
    }
  }

  /**
   * setScrollToWindow
   * windowScroll storage 의 스크롤 값을 window 에 지정
   */
  setScrollToWindow = () => {
    const nScroll = this.getStorage("windowScroll");
    if (!nScroll) {
      return;
    }

    TMON.oApp.oUtil.scrollTop(this, nScroll);
  };

  /**
   * setScrollToStorage
   * window 의 스크롤 값을 windowScroll storage 에 지정
   */
  setScrollToStorage = () => {
    const nScroll = $(window).scrollTop();
    this.setStorage("windowScroll", nScroll);
  };

  /**
   * 페이지 스크롤 eventListener
   * scroll 이벤트 발생 시 실행
   * @param nScrollTop 현재 $(window).scrollTop();
   */
  onScroll(nScrollTop) {
    if (this.oNavigation && typeof this.oNavigation.onScroll === "function") {
      this.oNavigation.onScroll(nScrollTop);
    }
    if (this.oFastScroll && typeof this.oFastScroll.onScroll === "function") {
      this.oFastScroll.onScroll();
    }
    if (this.oPurchase && typeof this.oPurchase.onScroll === "function") {
      this.oPurchase.onScroll();
    }
    if (this.oToast && typeof this.oToast.onScroll === "function") {
      this.oToast.onScroll();
    }
    if (this.oCommonToast && typeof this.oCommonToast.onScroll === "function") {
      this.oCommonToast.onScroll();
    }
    if (
      this.oDealContents &&
      typeof this.oDealContents.onScroll === "function"
    ) {
      this.oDealContents.onScroll();
    }
    if (
      this.oShareCapture &&
      typeof this.oShareCapture.onScroll === "function"
    ) {
      this.oShareCapture.onScroll(nScrollTop);
    }
  }

  /**
   * 사용자가 보고있는 창의 크기 변경 eventListener
   * resize 이벤트 발생 시 실행
   */
  onResize() {
    if (this.oPurchase && typeof this.oPurchase.onResize === "function") {
      this.oPurchase.onResize();
    }
    if (
      this.oDealContents &&
      typeof this.oDealContents.onResize === "function"
    ) {
      this.oDealContents.onResize();
    }
  }

  /**
   * view 가 view-default 이고, scene이 scene-default일 때 특정 탭을 활성화하는 함수
   * @param {object} htInfo 활성화할 탭에 대한 정보를 담은 객체
   *  {{
   *      sTabId 활성화할 탭의 id
   *      bScrollToTab 탭 내비게이션이 화면 최상단으로 오도록 스크롤할지 말지 여부
   *  }}
   */
  async enableTab(htInfo) {
    let sEnableTabId = htInfo.sTabId;
    if (!htInfo.sTabId) {
      sEnableTabId = $("#tab-navigation a")
        .eq(0)
        .attr("data-tab-id");
    }

    // 리뷰/문의, 상품문의·상품리뷰 탭 관련 api
    // 리뷰 관련 API 서버(boardapi)는 감당할 수 있는 부하가 크지 않아 탭이 눌렸을 때 최초 1회만 API를 호출함
    if (
      sEnableTabId === "review" &&
      // 1회만 호출하기 위해 이전에 호출한 데이터가 있는지 확인
      !TMON.oApp.htStorage.reviewSurveyStatistics
    ) {
      await this.oApi.fetchApi("reviewSurveyStatistics");
      await this.oApi.fetchApi("reviewFixSurveyStatistics");
      this.oApi.fetchApi("photoReviewList", {
        bShowSCReview: TMON.htStaticData.htDealInfo.isScDeal,
      });
      this.oApi.fetchApi("photoReviewImageCount", {
        bShowSCReview: TMON.htStaticData.htDealInfo.isScDeal,
      });
      this.oApi.fetchApi("reviewOptionTree");
    }

    const nHeaderHeight = this.oUtil.getHeaderHeight();
    this.setStorage("tab", sEnableTabId);

    if (htInfo.bScrollToTab) {
      this.scrollTab(nHeaderHeight, htInfo.nScrollHeight);
    }

    $("#tab-navigation li").removeClass("selected");
    $("#tab-navigation a").removeClass("on");
    $(`#tab-navigation a[data-tab-id=${sEnableTabId}]`)
      .closest("li")
      .addClass("selected");
    $(`#tab-navigation a[data-tab-id=${sEnableTabId}]`).addClass("on");
    $("[data-role=content-rely-tab]").hide();
    $(`[data-role=content-rely-tab][data-name=${sEnableTabId}]`).show();

    if (sEnableTabId === "description") {
      TMON.oApp.setStorage("setSummaryOptionHeight", true); // description 탭이 활성화되면, Summary 딜의 option content 의 height 를 재정의해줘야 한다.
      if (TMON.oApp.oDealContents) TMON.oApp.oDealContents.renderViewMoreBtn(); // IMAGE 컨텐츠 딜을 다른 탭으로 열고 상품설명 탭으로 이동시 더보기 버튼 안보이는 이슈 대응
    }
  }

  /**
   * 탭으로 스크롤 한다.
   * @param nHeaderHeight
   * @param nScrollHeight 스크롤 위치 값
   */
  scrollTab(nHeaderHeight, nScrollHeight) {
    if (this.oFastScroll) {
      this.oFastScroll.bAnimateScroll = true;
    }
    $("html, body").stop();

    // tab-inner
    // 스크롤 위치 값(nScrollHeight)이 있을 경우에 해당 위치로 스크롤해준다.
    const nDefaultScrollTop = $(".tab-wrap:first").offset().top - nHeaderHeight;
    const nTargetScrollTop =
      nScrollHeight > nDefaultScrollTop ? nScrollHeight : nDefaultScrollTop;
    $("html, body").animate({ scrollTop: nTargetScrollTop }, 100, () => {
      if (this.oFastScroll) {
        this.oFastScroll.bAnimateScroll = false;
        this.oFastScroll.onScroll();
      }
    });

    // 레이어가 떠서 body가 이미 fix가 되어 있을 경우에 스크롤이 안되기 떄문에 body의 margin값을 조절한다.
    if (TMON.util.isFixedBody()) {
      TMON.util.setFixedBodyScrollTop(0); // body가 fix되어서 margin-top 값이 적용이 되어 있을 경우, tab 엘리먼트의 offset top값을 제대로 계산할 수 없기 때문에 margin-top 값을 0 으로 바꿔주고 계산한다.
      const nNewOffsetTop = $(".tab-wrap:first").offset().top - nHeaderHeight;
      TMON.util.setFixedBodyScrollTop(nNewOffsetTop);
    }
  }

  /**
   * cloneHeader
   * 투명한 header 를 구현하기 위해 header 를 복사 (clone) 하여 추가함
   */
  cloneHeader() {
    const header = document.querySelector(".app_header_ui_wrap");
    if (!header) return;

    const blurred = header.querySelector(".hdr.blurred");
    if (blurred) blurred.querySelector(".hdr.blurred").remove();

    function back() {
      if (TMON.sListUrl) location.href = TMON.sListUrl;
      else history.back();
    }

    const original = header.querySelector(".hdr");
    if (original) {
      original.classList.add("_opacityChangeItem");
      const clone = original.cloneNode(true);
      clone.classList.remove("_opacityChangeItem");
      clone.classList.add("blurred");
      const cloneBtn = clone.children[2].children[0];
      cloneBtn.setAttribute("id", "_btnFirstBackBtn");
      cloneBtn.addEventListener("click", back);

      header.prepend(clone);
    }
  }
}

export default App;
